// extracted by mini-css-extract-plugin
export var content = "_94-3";
export var list = "_94-4";
export var settingsContent = "_94-7";
export var settingsPanel = "_94-8";
export var state = "_94-6";
export var triggerBadge = "_94-2";
export var triggerButton = "_94-1";
export var triggerShell = "_94-0";
export var unreadDot = "_94-5";